import {
  FormControlLabel,
  Stack,
  Switch as MuiSwitch,
  Typography,
} from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const Root = styled(Stack)(({ theme }) => ({
  minWidth: 220,
  padding: theme.spacing(1.5),
  gap: theme.spacing(0.25),
}));

export const Caption = styled(Typography)(({ theme }) => ({
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: 0.5,
  textTransform: "uppercase",
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.5),
}));

export const Row = styled(FormControlLabel)(({ theme }) => ({
  margin: 0,
  justifyContent: "space-between",
  gap: theme.spacing(2),
  padding: theme.spacing(0.5, 0),

  "&:not(:last-of-type)": {
    borderBottom: `1px solid ${alpha(theme.palette.text.primary, 0.06)}`,
  },

  "& .MuiFormControlLabel-label": {
    fontSize: 13,
    color: theme.palette.text.primary,
  },
}));

export const Switch = styled(MuiSwitch)(({ theme }) => ({
  width: 34,
  height: 20,
  padding: 0,
  overflow: "visible",
  flexShrink: 0,

  "& .MuiSwitch-switchBase": {
    padding: 2,
    margin: 0,
    transitionDuration: "150ms",

    "&.Mui-checked": {
      transform: "translateX(14px)",

      "& + .MuiSwitch-track": {
        backgroundColor: `${theme.palette.success.main} !important`,
        opacity: 1,
      },
    },
  },

  "& .MuiSwitch-thumb": {
    width: 16,
    height: 16,
    boxShadow: "none",
    backgroundColor: theme.palette.common.white,
  },

  "& .MuiSwitch-track": {
    width: 34,
    height: 20,
    borderRadius: 999,
    opacity: 1,
    backgroundColor: `${
      theme.palette.mode === "dark"
        ? theme.palette.grey[700]
        : theme.palette.grey[300]
    } !important`,
  },
}));
